import { Upload } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid } from '@mui/material'
import { GreenText } from 'components'
import {
  MichiganSOSBundleTitleApplicationDeliveryPhotoDto,
  michiganSOSBundleTitleApplicationDeliveryPhotoValidationSchema
} from 'dtos'
import { Form, Formik } from 'formik'

interface UploadReplaceTitleApplicationDeliveryPhotoDialogProps {
  initialValues: MichiganSOSBundleTitleApplicationDeliveryPhotoDto
  isLoading: boolean
  michiganSoSBundleGuid: string
  onClose: () => void
  onSave: (values: MichiganSOSBundleTitleApplicationDeliveryPhotoDto) => void
  open: boolean
}

export default function UploadReplaceTitleApplicationDeliveryPhotoDialog({
  initialValues,
  isLoading,
  michiganSoSBundleGuid,
  onClose,
  onSave,
  open
}: UploadReplaceTitleApplicationDeliveryPhotoDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur
        validateOnChange
        validationSchema={michiganSOSBundleTitleApplicationDeliveryPhotoValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <DialogTitle>Title Application Delivery Photo</DialogTitle>

                <Grid item xs={12}>
                  <img
                    alt='Title Application Delivery' /* Photo'*/
                    src={
                      values.titleApplicationDeliveryPhotoFile
                        ? URL.createObjectURL(values.titleApplicationDeliveryPhotoFile)
                        : values.titleApplicationDeliveryPhotoFileName
                        ? `/api/michigan-sos-bundles/${encodeURIComponent(
                            michiganSoSBundleGuid!
                          )}/title-application-delivery-photo/${encodeURIComponent(
                            values.titleApplicationDeliveryPhotoFileName
                          )}`
                        : undefined
                    }
                    style={{ width: '100%' }}
                  />

                  <input
                    type='file'
                    hidden
                    accept='.png,.jpg,.jpeg'
                    id='titleApplicationDeliveryPhotoFile'
                    onChange={e => {
                      if (e.target.files && e.target.files.length > 0) {
                        setFieldValue('titleApplicationDeliveryPhotoFile', e.target.files[0])
                      }
                    }}
                  />
                </Grid>

                {errors.titleApplicationDeliveryPhotoFile && (
                  <Grid item xs={12}>
                    <FormHelperText error>{errors.titleApplicationDeliveryPhotoFile}</FormHelperText>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <LoadingButton
                    color='primary'
                    disabled={isLoading}
                    endIcon={<Upload />}
                    fullWidth
                    onClick={() => {
                      document.getElementById('titleApplicationDeliveryPhotoFile')?.click()
                    }}
                    variant='text'
                  >
                    UPLOAD NEW IMAGE
                  </LoadingButton>
                </Grid>

                <Grid item xs={12}>
                  <GreenText variant='outlined'>
                    {`**Upload New Image Button:**

Press “Upload New Image” to associate a Title Application Delivery Photo to the MI SoS Bundle. Any existing Title Application Delivery Photo will be overwritten.`}
                  </GreenText>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button color='secondary' disabled={isLoading} onClick={onClose} variant='text'>
                CANCEL
              </Button>

              <LoadingButton color='primary' disabled={isLoading} type='submit' variant='contained'>
                SAVE
              </LoadingButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
